.searchInputContainer {
  position: relative;
  min-width: 45rem;
}

.clearButton {
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
}

.infoButton {
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  color: var(--text-color-secondary);
}

.helpContent {
  p {
    margin-bottom: 1rem;
    font-size: 1rem;
    color: var(--text-color);
  }
}

.operatorTable {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;

  th,
  td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid var(--surface-border);
    vertical-align: top;
  }

  th {
    background-color: var(--surface-100);
    font-weight: 600;
    color: var(--text-color);
    border-bottom: 2px solid var(--surface-border);
  }

  td {
    color: var(--text-color-secondary);

    strong {
      color: var(--text-color);
      font-weight: 600;
    }

    code {
      background-color: var(--surface-100);
      padding: 0.2rem 0.4rem;
      border-radius: 0.25rem;
      font-family: SFMono-Regular, Consolas, 'Liberation Mono', Menlo, Courier, monospace;
      font-size: 0.875rem;
      color: var(--pink-500);
    }
  }

  tbody tr:hover {
    background-color: var(--surface-hover);
  }
}
